export type EmailAliasErrorType = 'emailTaken' | 'cooldown' | 'alreadyConfirmed' | 'invalidCode' | 'notFound' | 'forbidden' | 'unknown';

const HTTP_STATUS_FORBIDDEN = 403;
const HTTP_STATUS_NOT_FOUND = 404;
const HTTP_STATUS_UNPROCESSABLE = 422;

interface ThrownErrorShape {
    response?: {
        status?: number;
        data?: {errors?: Record<string, unknown>};
    };
}

const VALIDATION_KEY_TO_ERROR_TYPE: Record<string, EmailAliasErrorType> = {
    email: 'emailTaken',
    confirmation_sent_at: 'cooldown',
    confirmed_at: 'alreadyConfirmed',
    confirmation_token: 'invalidCode'
};

/** Classifies a failed email-alias request by HTTP status and validation field key, never by message text. */
export const getEmailAliasErrorType = (error: unknown): EmailAliasErrorType => {
    const response = (error as ThrownErrorShape | undefined)?.response;

    if (response?.status === HTTP_STATUS_NOT_FOUND) return 'notFound';
    if (response?.status === HTTP_STATUS_FORBIDDEN) return 'forbidden';
    if (response?.status !== HTTP_STATUS_UNPROCESSABLE) return 'unknown';

    const matchedKey = Object.keys(response.data?.errors ?? {}).find((fieldKey) => Object.prototype.hasOwnProperty.call(VALIDATION_KEY_TO_ERROR_TYPE, fieldKey));

    return matchedKey ? VALIDATION_KEY_TO_ERROR_TYPE[matchedKey] : 'unknown';
};
